<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="'70%'" [nzVisible]="isVisible"
  [nzTitle]="projectPlanDrawerHeader" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <ng-template #projectPlanDrawerHeader>
    <div style="display: flex; justify-content: space-between; align-items: center;" class="ant-drawer-title">
      {{projectPlanData?.project_details?.name}}

      <button *ngIf="stepIndex === 1" nz-button nzType="primary" (click)="addNewQuestion()">Update Questions</button>
    </div>
  </ng-template>


  <div nz-row *nzDrawerContent>
    <!-- <div nz-col [nzSpan]="6">
      <nz-steps  [nzCurrent]="stepIndex" (nzIndexChange)="onIndexChange($event)">
        <nz-step nzTitle="On-Boarding Questions" nzDescription="Fill in the details" nzIcon="solution"></nz-step>
        <nz-step nzTitle="Done" nzDescription="Review & Save" nzIcon="smile"></nz-step>
      </nz-steps>
    </div> -->

    <div nz-col [nzSpan]="24">

      <div nz-row>
        <div nz-col [nzSpan]="5">
          <nz-steps [nzCurrent]="stepIndex" (nzIndexChange)="onIndexChange($event)" nzDirection="vertical"
            style="height: 450px;">
            <nz-step nzTitle="Project Info" nzIcon="project"></nz-step>
            <nz-step nzTitle="Edit On-Boarding Questions" nzIcon="solution"></nz-step>
            <nz-step nzTitle="Review & Save" nzIcon="smile"></nz-step>
          </nz-steps>
        </div>

        <div nz-col [nzSpan]="19">


          <ng-container *ngIf="stepIndex === 0">
            <!-- <nz-card [nzTitle]="projectDetailTitle" style="margin-bottom: 10px;" *ngIf="projectPlanData">
              <ng-template #projectDetailTitle>
                {{projectPlanData.project_details.name}}
              </ng-template>
            </nz-card> -->

            <nz-descriptions [nzColumn]="1" nzSize="middle" nzBordered *ngIf="projectPlanData">
              <nz-descriptions-item nzTitle="Project ID">
                <nz-tag> {{ formatIdToFourDigits(projectPlanData.project_details.id) }} </nz-tag>
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Client">
                <strong> {{projectPlanData?.project_details.client_name}}</strong>
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Status">
                <nz-tag [nzColor]="getStatusColor(projectPlanData.project_details.status_name)">
                  {{ projectPlanData.project_details.status_name }} </nz-tag>
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Due Date">
                <nz-tag> {{ projectPlanData.project_details.due_date }} </nz-tag>
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Project Type">
                <nz-tag> {{ projectPlanData.project_details.project_type_name }} </nz-tag>
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Contact Type">
                {{projectPlanData.project_details.contact_type_name}}
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Contract Files">
                <div *ngFor="let item of projectPlanData.project_details.contract_file_details">
                  <a [href]="item.file" target="_blank"><nz-icon nzType="file" nzTheme="outline" /> {{item.name}}</a>
                </div>
              </nz-descriptions-item>


              <nz-descriptions-item nzTitle="Customer Success Manager">
                <nz-tag [nzColor]="'cyan'" class="user-badge" [nzBordered]="false">
                  <nz-avatar nzSize="small"
                  [nzSrc]="projectPlanData.project_details.customer_success_manager_image ? getBase64Image(projectPlanData.project_details.customer_success_manager_image) : null"
                    [nzText]="projectPlanData.project_details.customer_success_manager_name ? projectPlanData.project_details.customer_success_manager_name[0].toUpperCase() : '?'" style="margin-right: 4px;"></nz-avatar>
                  {{ projectPlanData.project_details.customer_success_manager_name ? projectPlanData.project_details.customer_success_manager_name : '&nbsp;-' }}
                </nz-tag>
              </nz-descriptions-item>



              <nz-descriptions-item nzTitle="Description">
                <div [innerHTML]="projectPlanData.project_details.description"></div>
              </nz-descriptions-item>


            </nz-descriptions>


          </ng-container>

          <ng-container *ngIf="stepIndex === 1">
            <form (ngSubmit)="nextStep()" #questionForm="ngForm">
              <div *ngFor="let q of questions; track q; let index=index; ">
                <nz-card class="onboarding-question-card" style="margin-bottom: 10px;">
                  <div class="onboarding-question-title">
                    <strong>Q{{index + 1}}:</strong> {{ q.text }}
                  </div>


                  <textarea *ngIf="q.type === 'Textarea'" rows="4" nz-input [(ngModel)]="q.answer" [name]="'q' + q.id"
                    style="margin-top: 10px;"></textarea>


                  <input *ngIf="q.type === 'Text'" nz-input [(ngModel)]="q.answer" [name]="'q' + q.id" />

                  <nz-select *ngIf="q.type === 'Select One'" [(ngModel)]="q.answer" [name]="'q' + q.id" nzShowSearch nzAllowClear
                    nzPlaceHolder="Please select" style="width: 100%;">
                    <nz-option *ngFor="let opt of q.options" [nzValue]="opt" [nzLabel]="opt"></nz-option>
                  </nz-select>


                  <nz-checkbox-group *ngIf="q.type === 'Multi Select'" [(ngModel)]="q.answer" [name]="'q' + q.id"
                    [nzOptions]="getCheckboxOptions(q)"></nz-checkbox-group>

                    <!--Multiple Files -->

                    <nz-form-control class="fileUpload"  *ngIf="q.type === 'Multiple files'"   >
                      <nz-upload    [nzSize]="5120"  [id]="'q' + q.id"
                      [nzCustomRequest]="customUploadRequest"
                        nzListType="picture" [nzBeforeUpload]="beforeUpload"
                        (nzChange)="onUploadContractChange($event, index)"
                        [(nzFileList)]="scfileList">
                        <button nz-button  (click)="removeDefault($event)">
                          <i nz-icon nzType="paper-clip"></i> Attach Files
                        </button>
                      </nz-upload>
                        <p style="font-size:10px;font-weight: 500;font-style: italic;color:grey;
                        position:absolute;right:10px;top:6px"> Accepted formats: .pdf, .jpeg, .jpg etc. (Add max file size 5 MB)</p>
                      <!-- <p  style="font-size:14px;color:red;width:100%;text-align:left">Please add Contract file</p> -->
                    </nz-form-control>

                  <nz-alert *ngIf="deleteMultiFileAction != null && q.type === 'Multiple files'" style="position:fixed; bottom:60px; right:20px" nzCloseable nzType="warning" nzMessage="Are you sure you want to delete?" [nzAction]="actionTemplate3"></nz-alert>
                    <ng-template #actionTemplate3>
                      <button nz-button nzSize="small" nzType="primary" nzGhost (click)="cancelRemoveMultiFile($event)">Close</button>
                      <button nz-button nzSize="small" nzType="primary" nzGhost (click)="removeMultiFile($event,deleteMultiFileAction,index)">Ok</button>
                    </ng-template>

                   <!--  Files -->


                    <nz-form-control  *ngIf="q.type === 'File'" class="fileUpload">
                      <nz-upload    [nzSize]="5242880" [nzDisabled]="fileList.length==1"  [id]="'q' + q.id"
                      [nzCustomRequest]="customUploadRequest"
                        nzListType="picture" [nzBeforeUpload]="beforeUpload"
                        (nzChange)="onUploadAdditionalChange($event, index)"
                        [(nzFileList)]="fileList" >
                        <button nz-button (click)="removeDefault($event)">
                          <i nz-icon nzType="paper-clip"></i> Attach Files
                        </button>
                      </nz-upload>
                        <p style="font-size:10px;font-weight: 500;font-style: italic;color:grey;
                        position:absolute;right:10px;top:6px"> Accepted formats: .pdf, .jpeg, .jpg etc. (Add max file size 5 MB)</p>
                    </nz-form-control>

                    <nz-alert *ngIf="deleteFileAction != null && q.type === 'File'" style="position:fixed; bottom:60px; right:20px" nzCloseable nzType="warning" nzMessage="Are you sure you want to delete?" [nzAction]="actionTemplate4"></nz-alert>
                    <ng-template #actionTemplate4>
                      <button nz-button nzSize="small" nzType="primary" nzGhost (click)="cancelRemoveFile($event)">Close</button>
                      <button nz-button nzSize="small" nzType="primary" nzGhost (click)="removeFile($event,deleteFileAction,index)">Ok</button>
                    </ng-template>
                </nz-card>
              </div>
            </form>



          </ng-container>

          <!-- Step 1: Final Step -->
          <ng-container *ngIf="stepIndex === 2">
            <nz-card nzTitle="Final Step">
              <p>You have finished the onboarding process. Review your answers and click save to complete.</p>

              <nz-list nzSize="small">
                @for (q of questions; track q.id;) {
                <nz-list-item style="padding: 0;">
                  <div>
                    <p style="margin-top: 10px;"><strong>Q{{$index + 1}}: {{ q.text }}</strong></p>
                    <!-- <nz-divider style="margin-top: 0; margin-bottom: 10px;">  </nz-divider> -->
                    <p>
                      <ng-container *ngIf="Array.isArray(q.answer); else singleAnswer">
                        <ul *ngIf="q.type === 'File' || q.type === 'Multiple files'; else textAnswer">
                          <li *ngFor="let ans of q.answer">{{ getFiles(q.type,ans) }}</li>
                        </ul>
                        <ng-template #textAnswer>
                          <ul >
                             <li *ngFor="let ans of q.answer">{{ ans }}</li>
                          </ul>
                        </ng-template>

                      </ng-container>
                      <ng-template #singleAnswer>
                        <p> {{ q.answer || 'N/A' }}</p>
                      </ng-template>
                    </p>
                  </div>
                </nz-list-item>
                }
              </nz-list>



            </nz-card>
          </ng-container>


        </div>
      </div>


    </div>
  </div>

  <ng-template #footerTpl>

    <div style="float: right">
      <button nz-button style="margin-right: 8px" (click)="close()">Cancel</button>
      <button *ngIf="stepIndex != 2" nz-button nzType="primary" (click)="nextStep()">
        Next
      </button>
      <button *ngIf="stepIndex === 2" nz-button nzType="primary" (click)="submitAnswers()">
        Save
      </button>
    </div>

  </ng-template>
</nz-drawer>


<nz-modal [(nzVisible)]="isVisibleAddQuestion" nzTitle="Questions" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>

    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input type="text" [(ngModel)]="nameSearchModel" (ngModelChange)="onSearchChange($event)" nz-input
        placeholder="Search" />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <nz-icon nzType="search" />
    </ng-template>


    <div style="min-height: 250px; max-height: 350px; overflow: auto; margin-top: 20px;">

      <div *ngFor="let q of projectQuestion.value.results; let index=index;">
        <app-question-input [label]="q.question" [id]="q.id" [checked]="isCheckedQuation(q.id)"
          (checkedChange)="checkedChange($event)"></app-question-input>
      </div>

    </div>

  </ng-container>
</nz-modal>
<app-loader *ngIf="loading"></app-loader>
